import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { InputBase, Menu } from '@mantine/core';
import { DatePicker } from '@mantine/dates';

import { ChevronDownIconSm } from '@chownow/pantry/icons';

interface CalendarSelectProps {
  value: string;
  onSelectNewDay: (value: Date) => void;
}

export default function CalendarSelect({ value, onSelectNewDay }: CalendarSelectProps) {
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    // close dropdown when value changes
    setOpened(false);
  }, [value]);

  return (
    <Menu position="bottom-start" opened={opened} onChange={setOpened}>
      <Menu.Target>
        <InputBase
          component="button"
          type="button"
          pointer
          rightSection={<ChevronDownIconSm />}
          rightSectionPointerEvents="none"
          size="sm"
          w={132}
          mr="sm"
        >
          {value}
        </InputBase>
      </Menu.Target>
      <Menu.Dropdown w="auto">
        <DatePicker
          p="sm"
          allowDeselect={false}
          onChange={date => date && onSelectNewDay(dayjs(date).toDate())}
          value={dayjs(value).toDate()}
        />
      </Menu.Dropdown>
    </Menu>
  );
}
